import { useClickAway } from '@ipfabric/ui-components/hooks/useClickAway';
import type { Awaitable } from '@ipfabric/ui-components/utils/types/Awaitable';
import { Button } from 'components/Button/Button';
import { useState } from 'react';
import type { FC } from 'react';
import type { InfiniteScrollItemsResult } from 'utils/react/useInfiniteScrollItems';
import type { FacetedFilterValue } from './FacetedFilter';
import {
  type FacetedFilterAttributeOption,
  FacetedFilterNewAttributeSelect,
} from './FacetedFilterNewAttributeSelect';

interface Props {
  value: FacetedFilterValue;
  onChange: (value: FacetedFilterValue) => void;
  loadAttributes: (
    startIndex: number,
    filter: string,
  ) => Awaitable<InfiniteScrollItemsResult<FacetedFilterAttributeOption>>;
}

const facetedFilterMsg = {
  addAttribute: 'Add attribute',
  select: 'Select',
  selectAttribute: 'Select attribute',
  search: 'Search',
  selectValues: 'Select value(s) for',
  selectAll: 'Select all',
  selectAllFiltered: 'Select all search results',
  noAttributeFoundSnapshot: 'There are no attributes for selected snapshot.',
  noAttributeFoundFilter: 'There are no attributes for selected search query.',
  noValueFoundSnapshot:
    'There are no values for this attribute for selected snapshot.',
  noValueFoundFilter:
    'There are no values for this attribute for selected search query.',
};

export const FacetedFilterNewAttribute: FC<Props> = (props) => {
  const [open, setOpen] = useState<boolean>(false);

  const wrapperRef = useClickAway<HTMLDivElement>(() => {
    setOpen(false);
  });

  const selectOption = (option: string) => {
    props.onChange({
      ...props.value,
      [option]: [],
    });

    setOpen(false);
  };

  return (
    <div className='relative' ref={wrapperRef}>
      <Button
        type='button'
        variant='tertiary'
        icon='fa-circle-plus'
        onClick={() => {
          setOpen(true);
        }}
        onFocus={() => {
          setOpen(true);
        }}
        dataTestId='add-attribute-button'
      >
        {facetedFilterMsg.addAttribute}
      </Button>
      {open && (
        <FacetedFilterNewAttributeSelect
          selectOption={selectOption}
          loadAttributes={props.loadAttributes}
          wrapperRef={wrapperRef}
          selected={Object.keys(props.value)}
        />
      )}
    </div>
  );
};
